module.exports = __webpack_public_path__ + "img/20190826132755360截图20190824150130216.f6e947d3.jpg";